module.exports = __webpack_public_path__ + "static/media/salmah-bio.f706a326.pdf";